/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint-disable import/no-unresolved, import/default */

import aerationWidgetTemplate from './aeration-widget.tpl.html';
import aerationWidgetToolbarTemplate from './aeration-widget-toolbar.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.aerationWidget', [])
    .directive('agAerationWidget', AerationWidget)
    .name;

/*@ngInject*/
function AerationWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AerationWidgetController,
        controllerAs: 'vm',
        templateUrl: aerationWidgetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function AerationWidgetController($scope, $element, $compile, $templateCache, $translate, agTypes) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.aerationIcon = "ag:aeration";

    var parents = $element.parents('.tb-widget');
    parents.children('.tb-widget-header').css('paddingRight', '40px');
    $element.parents('.tb-widget-content').css('paddingRight', '40px');

    var toolbarTemplate = $templateCache.get(aerationWidgetToolbarTemplate);
    var toolbarElement = angular.element(toolbarTemplate);
    angular.element(parents[1]).append(toolbarElement);
    $compile(toolbarElement.contents())($scope);

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.aerationIcon = (vm.ctx.stateController.getStateParams().aerationType == agTypes.aerationType.alarm) ? "ag:aeration_alarm" : "ag:aeration";
            vm.ctx.aerationWidgetTypes = agTypes.aerationWidgetType;
            vm.ctx.currentWidgetType = agTypes.aerationWidgetType.aerationDetails;
            vm.ctx.settings.displayPagination = false;
            vm.ctx.settings.alarmsTitle = $translate.instant('alarm.alarms') + ': ${entityName}';

            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newAerationId, prevAerationId) {
                    if (newAerationId && !angular.equals(newAerationId, prevAerationId)) {
                        vm.aerationIcon = (vm.ctx.stateController.getStateParams().aerationType == agTypes.aerationType.alarm) ? "ag:aeration_alarm" : "ag:aeration";
                    }
                }
            );
        }
    });

    $scope.$on('siteAssetUpdated', function(event, siteAsset) {
        vm.aerationIcon = (siteAsset.aerationType == agTypes.aerationType.alarm) ? "ag:aeration_alarm" : "ag:aeration";
    });
}
